goog.provide('el8.ptdata.model.amendmentRequest');

goog.require('el8.model.base');

(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty("requestDescription", true);
    _class.addStringProperty("status", true);
    _class.addStringProperty("amendmentSource", true);
    _class.addDateTime("requestTime", true);
    _class.addDateTime("statusUpdatedTime", true);

    _class.prototype.isAccepted = function() {
        return this.getStatus() === 'accepted';
    };

    el8.ptdata.model.amendmentRequest = function(spec) { return new _class(spec); };

})();

